import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ContentLoader } from '@saucelabs/sl-component-loader';
import NotificationsContainer from '@saucelabs/sl-container-notifications';
import ErrorPagesContainer from '@saucelabs/sl-container-error-pages';

import * as actions from './../actions';
import Styles from './ApplicationContainer.styles';
import AccountExpiredContainer from '../../account-expired/containers/AccountExpiredContainer';


const ErrorPagesWithRouter = withRouter(ErrorPagesContainer);
class Application extends Component {
  componentDidMount() {
    const { initialize } = this.props;
    initialize(null, { skipErrorPage: true });
  }

  componentWillUnmount() {
    const { stop } = this.props;
    stop();
  }

  renderContent() {
    const {
      children,
      initialized,
      unauthenticated,
      unverified,
    } = this.props;

    if (!unauthenticated && initialized && unverified) {
      return <Redirect to={{ pathname: '/verify-email' }} />;
    }

    return (
      <div className={Styles.content}>
        <Helmet
          defaultTitle="Sauce Labs"
          titleTemplate="Sauce Labs | %s"
        />
        <NotificationsContainer />
        <ErrorPagesWithRouter>
          <AccountExpiredContainer />
          {children}
        </ErrorPagesWithRouter>
      </div>
    );
  }

  render() {
    const { initialized } = this.props;


    return (
      <ContentLoader show={!initialized}>
        {this.renderContent()}
      </ContentLoader>
    );
  }
}

Application.propTypes = {
  children: PropTypes.node.isRequired,
  initialize: PropTypes.func.isRequired,
  initialized: PropTypes.bool.isRequired,
  stop: PropTypes.func.isRequired,
  unauthenticated: PropTypes.bool.isRequired,
  unverified: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ apps: { app }, user }) => ({
  unauthenticated: app.get('unauthenticated'),
  unverified: !user.get('verified'),
  initialized: app.get('initialized'),
});

const mapDispatchToProps = {
  initialize: actions.initialize,
  stop: actions.stop,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Application));
export { Application, mapStateToProps, mapDispatchToProps };
